module.exports = __webpack_public_path__ + "images/mic-filled76cbd35817e29ff70ac3a2654464f2b1.svg";